import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { fetchDatasets } from '../api';
import { ExternalLink, ArrowLeft } from 'lucide-react';

export default function PlaceholderDataset({ slug, title, kicker, blurb, source, sourceUrl }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    fetchDatasets().then(r => setD((r.datasets || []).find(x => x.key === slug))).catch(() => {});
  }, [slug]);

  return (
    <div className="min-h-screen bg-cream-100 text-ink-700">
      <Header />
      <section className="bg-ink-800 text-cream-100">
        <div className="max-w-5xl mx-auto px-6 lg:px-12 py-16">
          <Link to="/" className="inline-flex items-center gap-1.5 text-[13px] text-cream-100/65 hover:text-copper-500 mb-6 transition">
            <ArrowLeft size={14} /> Home
          </Link>
          <div className="kicker text-copper-500 mb-4">{kicker}</div>
          <h1 className="font-serif text-[56px] md:text-[64px] leading-[0.98] tracking-tight">{title}</h1>
          <p className="mt-6 text-[16px] text-cream-100/75 max-w-2xl leading-relaxed">{blurb}</p>
        </div>
      </section>

      <main className="max-w-5xl mx-auto px-6 lg:px-12 py-16">
        {d && (
          <div className="bg-cream-50 border border-ink-300/60 rounded-sm p-12 md:p-16">
            <div className="kicker text-copper-600 mb-6">{d.label}</div>
            <div className="font-serif text-[72px] md:text-[100px] leading-[0.9] tracking-tight text-ink-800 tabular">{d.value}</div>
            <div className="mt-5 text-[15px] text-ink-500">{d.sub}</div>
          </div>
        )}

        <div className="mt-10 text-[14px] text-ink-500 leading-relaxed">
          <strong className="text-ink-700">Source:</strong> {source}
          {sourceUrl && (
            <a href={sourceUrl} target="_blank" rel="noopener noreferrer" className="ml-2 inline-flex items-center gap-1 text-copper-600 hover:text-copper-500">
              view <ExternalLink size={11} />
            </a>
          )}
        </div>
        <div className="mt-6 text-[13px] text-ink-500 italic max-w-2xl">
          Detail tables, by-province slices, by-year trend lines and downloadable CSVs are queued for the next data sprint — the headline figure here is the published source value.
        </div>
      </main>
      <Footer />
    </div>
  );
}
